import Box from '@mui/material/Box';
import { useCallback, useState } from 'react';

import { DashboardTopBar } from '@common/components/DashboardTopBar';
import { TOP_BAR_HEIGHT_PX } from '@common/components/TopBar';
import { Snackbar } from '@modules/snackbar/components/Snackbar';

import { FloorplanCreator } from './FloorplanCreator';
import { FloorplanDuplicator } from './FloorplanDuplicator';
import { FloorplanDeleter } from './FloorplanDeleter';
import { FloorplanLayout } from './FloorplanLayout';
import { FloorplanContextMenu } from './contextMenu/FloorplanContextMenu';
import { useFloorplanAdmin, useFloorplanDownload } from './hooks';

const boxStyle = {
  pt: TOP_BAR_HEIGHT_PX,
  height: '100vh',
  overflowY: 'scroll',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  zIndex: 1,
};

export function FloorplanAdmin() {
  const { projectIsLoading, alternativesAreLoading } = useFloorplanAdmin();
  const { downloadSelectedFloorplan, isDownloading } = useFloorplanDownload();
  const [creatorIsOpen, setCreatorIsOpen] = useState(false);
  const [deleterIsOpen, setDeleterIsOpen] = useState(false);
  const [duplicatorIsOpen, setDuplicatorIsOpen] = useState(false);

  const openCreator = useCallback(() => {
    setCreatorIsOpen(true);
  }, []);
  const closeCreator = useCallback(() => {
    setCreatorIsOpen(false);
  }, []);

  const openDeleter = useCallback(() => {
    setDeleterIsOpen(true);
  }, []);
  const closeDeleter = useCallback(() => {
    setDeleterIsOpen(false);
  }, []);

  const openDuplicator = useCallback(() => {
    setDuplicatorIsOpen(true);
  }, []);
  const closeDuplicator = useCallback(() => {
    setDuplicatorIsOpen(false);
  }, []);

  return (
    <Box position="relative">
      <DashboardTopBar
        showLoading={projectIsLoading || alternativesAreLoading}
      />

      <Box sx={boxStyle}>
        <FloorplanLayout
          downloadIsDisabled={isDownloading}
          downloadSelectedFloorplan={downloadSelectedFloorplan}
          openCreator={openCreator}
          openDeleter={openDeleter}
          openDuplicator={openDuplicator}
        />

        <FloorplanCreator isOpen={creatorIsOpen} onCloseClick={closeCreator} />
        <FloorplanDeleter isOpen={deleterIsOpen} onCloseClick={closeDeleter} />
        <FloorplanDuplicator
          isOpen={duplicatorIsOpen}
          onCloseClick={closeDuplicator}
        />

        <Snackbar
          justifyContent="center"
          rightOffset="24px"
          bottomOffset="36px"
        />
      </Box>

      <FloorplanContextMenu
        downloadIsDisabled={isDownloading}
        onDeleteOptionClick={openDeleter}
        onDownloadOptionClick={downloadSelectedFloorplan}
      />
    </Box>
  );
}
